import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

const getInitialValue = (item) => {
    var value = item.value;

    if (item.type === "Checkbox") {
        return item.checked ? value : false;
    }

    return value;
};

const buildInitialValues = (args) => {
    var result = {};
    for (let i = 0; i < args.length; i++) {
        const item = args[i];
        result[item.name] = getInitialValue(item);
    }

    return result;
};

const buildValidationSchema = (args) => {
    var result = {};

    for (let i = 0; i < args.length; i++) {
        const item = args[i];

        let schema =
            item.inputMode === "number"
                ? Yup.number()
                : item.type === "Checkbox"
                ? Yup.bool()
                : Yup.string();

        if (item.required) {
            if (item.type === "Checkbox") {
                schema = schema.oneOf([true], item.requiredError);
            } else {
                schema = schema.required(item.requiredError);
            }
        }

        if (item.minLength) {
            schema = schema.test(
                "__custom-min-length",
                item.minLengthError,
                (value, cxt) => {
                    if (value === null || value === undefined) return true;
                    return ("" + value).length >= item.minLength;
                }
            );
        }

        if (item.maxLength) {
            schema = schema.test(
                "__custom-max-length",
                item.maxLengthError,
                (value, cxt) => {
                    if (value === null || value === undefined) return true;
                    return ("" + value).length <= item.maxLength;
                }
            );
        }

        if (item.min !== null && item.min !== undefined) {
            schema = schema.test(
                "__custom-min",
                item.rangeError,
                (value, cxt) => {
                    if (value === null || value === undefined) return true;
                    return parseFloat(value, 10) >= item.min;
                }
            );
        }

        if (item.max !== null && item.max !== undefined) {
            schema = schema.test(
                "__custom-max",
                item.rangeError,
                (value, cxt) => {
                    if (value === null || value === undefined) return true;
                    return parseFloat(value, 10) <= item.max;
                }
            );
        }

        if (item.regex) {
            schema = schema.matches(new RegExp(item.regex), item.regexError);
        }

        const customValidations = item.validations;

        if (customValidations) {
            for (let i = 0; i < customValidations.length; i++) {
                const validation = customValidations[i];
                schema = schema.test(
                    validation.name,
                    validation.message,
                    (value, cxt) => {
                        if (value === null || value === undefined) return true;
                        return validation.check({
                            value: value,
                            others: cxt.parent,
                        });
                    }
                );
            }
        }

        result[item.name] = schema;
    }

    return Yup.object().shape(result);
};

const useForm = (data, options) => {
    options = options || { validateOnMount: true };
    return useFormik({
        initialValues: buildInitialValues(data.inputs),
        validationSchema: buildValidationSchema(data.inputs),
        onSubmit: data.onSubmit,
        validateOnMount: options.validateOnMount,
    });
};

export const buildInput = (input, value, validations) => {
    return {
        ...input,
        value: value === null || value === undefined ? input.value : value,
        validations: validations,
    };
};

export default useForm;
